<template>
  <el-dialog :title="title" :visible.sync="visible" width="50%">
    <el-form :model="data" :rules="rules" ref="addForm" label-width="120px">
      <el-form-item label="文件夹名称:" prop="folderName">
        <el-input
          type="text"
          :maxlength="30"
          v-model="data.folderName"
          placeholder="请输入30字以内文件夹名称"
          clearable
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import { saveFolder ,folderDetail} from "@/api/saas/package";


export default {
  name: "AddClueDialog",
  components: {
  },

  props: {},
  data() {
    return {
      visible: false,
      rules: {
        folderName: [
          { required: true, message: "请输入文件夹名称", trigger: "change" }
        ]
      },
      folderObjs:{},
      title:'',
      data: {
        folderName: null,
      }
    };
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  watch: {
    visible(val) {
      if (!val) {
        this.resetFormData();
      }
    }
  },
  methods: {
    resetFormData () {
      this.data.companyId = null;
      this.resetForm("addForm");
    },
    // open() {
    //   this.visible = true;
    //   this.resetFormData();
    // },
    open(data, type) {
      this.visible = true;
      this.resetFormData()
      if(data){
        this.folderDetail(data)
      }
      console.log('data', this.data)
      console.log('type',type)
      if(type ==='edit') {
        this.title = '编辑文件夹'
        this.disabled = false
      }else{
        this.disabled = false
        this.title = '新增文件夹'
      }
    },
    folderDetail(data) {
      folderDetail({
        folderId: data.folderId
      })
        .then(response => {
          this.data = response.data;
          this.folderName=this.data.folderName;
          this.folderObjs = [{
            folderId: this.data.folderId,
            folderName: this.data.folderName
          }]
        })
        .catch(error => {});
    },
    confirm() {
      this.$refs["addForm"].validate(valid => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: "加载中",
            spinner: "el-icon-loading"
          });
          saveFolder(this.data)
            .then(response => {
              this.visible = false;
              this.$emit("success");
              loading.close();
              this.msgSuccess(this.data.folderId ? '编辑文件夹成功' : '新增文件夹成功');
            })
            .catch(error => {
              loading.close();
            });
        } else {
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    },
  }
};
</script>
